import * as msal from "@azure/msal-browser";
import { azureConfig } from "client.config";
import i18n from "../../i18n";
import initState from "./initState";
import {
  checkAndGetSessionStorageValue,
  checkUrlSearchParamsHas,
  getUrlSearchParamsValue,
} from "../../features/utils";

let accountObj = null;

let clientApplication;
const status = {
  Approved: "Approved",
  Denied: "Denied",
};

const msalConfig = {
  auth: {
    clientId: azureConfig.clientId,
    authority: azureConfig.authority,
    redirectUri: azureConfig.redirectUri,
    knownAuthorities: azureConfig.knownAuthorities,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

//5278 Set browser language as default language for non-login users.
export function tokenRequest() {
  var currentLanguage = checkAndGetSessionStorageValue("languageCode");

  return {
    scopes: azureConfig.b2cScopes,
    extraQueryParameters: { ui_locales: currentLanguage === "" ? "en" : currentLanguage }
  }
}

export function setAzureState({ props, state, setState }) {
  setState({
    azure: {
      ...state.azure,
      ...props,
    },
  });
}

export function createAzureClient({ state, actions, history }) {
  if (clientApplication) return;

  const errorMessage = "Error creating client instance for Microsoft Auth";

  try {
    clientApplication = new msal.PublicClientApplication(msalConfig);
  } catch (e) {
    console.log(errorMessage, e);
  }

  if (!clientApplication) {
    actions.setAzureState({
      error: errorMessage,
      createApplicationFailed: true,
    });
    return;
  }

  actions.setAzureState({
    error: null,
    createApplicationFailed: false,
  });

  actions.startAzureLogin({ history, checkOnly: true });
}

export function onAzureLoginSuccess({ props, actions, setState, state }) {
  const { accessToken, idTokenClaims = {}, account: user } = props;
  window.store = store;
  //744: changed
  localStorage.setItem("oid", user.idTokenClaims.sub);
  sessionStorage.setItem("IsValidUser", false);
  sessionStorage.setItem("isFacility", false);
  sessionStorage.setItem("isTravelAid2", false);
  setState({
    oid: user.idTokenClaims.sub,
  });
  localStorage.setItem("username", user.idTokenClaims.name);
  localStorage.setItem("email", user.idTokenClaims.email);
  localStorage.setItem("accessToken", accessToken);
  sessionStorage.setItem("accessToken", accessToken);

  actions.setAzureState({
    user,
    accessToken,
    idTokenClaims,
    error: null,
    loggedIn: true,
  });
}

export async function startAzureLogin({
  history,
  state,
  setState,
  actions,
  checkOnly = false,
}) {
  if (!clientApplication) {
    if (!state.azure.createApplicationFailed) {
      actions.createAzureClient({ history });
    }

    if (!clientApplication) return;
  }
  //5197 - block navigation to azure login for non-login-users
  if (sessionStorage.getItem("IsValidUser") !== "true" && sessionStorage.getItem("isFacility") !== "true" && sessionStorage.getItem("isTravelAid2") !== "true") {
    const onSuccess = (data) => actions.onAzureLoginSuccess(data);

    const onFail = ({ error, errorMessage }) => {
      console.log("Azure login: Fail", error);
      clientApplication.loginRedirect(tokenRequest());
      actions.setAzureState({
        error: errorMessage || "Failed to get access token for Microsoft Auth",
      });
    };

    await clientApplication
      .handleRedirectPromise()
      .then((tokenResponse) => {
        if (tokenResponse !== null) {
          accountObj = tokenResponse.account;
          setState({
            isDisplayLogin: true,
            oid: accountObj.idTokenClaims.sub,
          });
          localStorage.setItem("oid", accountObj.idTokenClaims.sub);

          sessionStorage.setItem("IsValidUser", false);
          sessionStorage.setItem("isFacility", false);
          sessionStorage.setItem("isTravelAid2", false);
          sessionStorage.setItem("LoginSucess", "true");
          sessionStorage.setItem("isPageRefreshed", "false");
          clientApplication.setActiveAccount(accountObj);

          if (state.azure.accessToken == null && !state.IsValidUser && !state.isFacility) {
            var languageFromAzure = accountObj.idTokenClaims.languageName;
            if (typeof window !== "undefined") {
              window.sessionStorage.setItem("languageCode", languageFromAzure);
            }
            i18n.changeLanguage(languageFromAzure);
            setState({
              languageCode: languageFromAzure,
              defaultLanguageCode: languageFromAzure
            });
          }
          onSuccess(tokenResponse);
          if (history) {
            history.push("/terms");
          }
        } else {
          var currentPath = window.location.pathname;
          var validOgId = null;
          validOgId= getUrlSearchParamsValue(window.location.search);
          if (currentPath === "/triageNew" || currentPath === "/terms" ) {
            if (
              checkUrlSearchParamsHas(window.location.search) ||
              sessionStorage.getItem("isTravelAid2") == "true"
            ) {
              var isFirstTimeLoad = sessionStorage.getItem("isFirstTimeLoad");

              var organizationId = null;
              if (sessionStorage.getItem("isTravelAid2") == "true") {
                setState({
                  isTravelAid2: true,
                });
                organizationId = localStorage.getItem("orgid");
              } else {
                organizationId = getUrlSearchParamsValue(window.location.search);
                localStorage.setItem("orgid", organizationId);
              }
              history.push({
                pathname: "/triageNew",
                search: "?organizationId=" + organizationId,
              });
            } else {
              const currentAccounts = clientApplication.getAllAccounts();
              if (!currentAccounts || currentAccounts.length === 0) {
                history.push("/");
                setState({
                  isLoading: false,
                });
              }
            }
          }
          else if (currentPath === "/find-facility") {
            if (
              checkUrlSearchParamsHas(window.location.search) ||
              sessionStorage.getItem("isFacility") == "true"
            ) {
              var isFirstTimeLoad = sessionStorage.getItem("isFirstTimeLoad");

              var organizationId = null;
              if (sessionStorage.getItem("isFacility") == "true") {
                setState({
                  isFacility: true,
                });
                organizationId = localStorage.getItem("orgid");
              } else {
                organizationId = getUrlSearchParamsValue(window.location.search);
                localStorage.setItem("orgid", organizationId);
              }

              history.push({
                pathname: "/find-facility",
                search: "?organizationId=" + organizationId,
              });
            } else {
              const currentAccounts = clientApplication.getAllAccounts();
              if (!currentAccounts || currentAccounts.length === 0) {
                history.push("/");
                setState({
                  isLoading: false,
                });
              }
            }
          }
          else if (currentPath === "/terms") {
            if (
              checkUrlSearchParamsHas(window.location.search) ||
              sessionStorage.getItem("IsValidUser") == "true"
            ) {
              var isFirstTimeLoad = sessionStorage.getItem("isFirstTimeLoad");

              var organizationId = null;
              if (sessionStorage.getItem("IsValidUser") == "true") {
                setState({
                  IsValidUser: true,
                });
                organizationId = localStorage.getItem("orgid");
              } else {
                organizationId = getUrlSearchParamsValue(window.location.search);
                localStorage.setItem("orgid", organizationId);
              }
              history.push({
                pathname: "/terms",
                search: "?organizationId=" + organizationId,
              });
            } else {
              const currentAccounts = clientApplication.getAllAccounts();
              if (!currentAccounts || currentAccounts.length === 0) {
                history.push("/");
                setState({
                  isLoading: false,
                });
              }
            }



          }
          else {
            setState({
              isDisplayLogin: true,
            });
            const currentAccounts = clientApplication.getAllAccounts();
            if (!currentAccounts || currentAccounts.length === 0) {
              if (history) {
                var currentUrl = window.location.pathname;
                if (
                  currentUrl !== "/create-profile" &&
                  currentUrl !== "/create-user" &&
                  currentUrl !== "/create-details" &&
                  currentUrl !== "/create-primary"
                ) {
                  if (sessionStorage.getItem("IsValidUser") !== "true" && sessionStorage.getItem("isTravelAid2") !== "true") {
                    history.push("/");
                  }
                }
              }

              // No user signed in
              return;
            } else if (currentAccounts.length > 1) {
              // More than one user signed in, find desired user with getAccountByUsername(username)
            } else if (currentAccounts.length === 1) {
              const activeAccount = currentAccounts[0];
              clientApplication.setActiveAccount(activeAccount);
            } else {
              accountObj = currentAccounts[0];
            }
          }
        }
        var userAccount = clientApplication.getAllAccounts();

        if (userAccount && userAccount.length > 0) {
          clientApplication
            .acquireTokenSilent({
              account: userAccount[0],
              redirectUri: azureConfig.redirectUri,
              scopes: azureConfig.b2cScopes,
            })
            .then((res) => {
              // Callback code here
              onSuccess(res);
            })
            .catch(async (error) => {
              if (error instanceof msal.InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails
                clientApplication
                  .acquireTokenRedirect({
                    account: userAccount[0],
                    redirectUri: azureConfig.redirectUri,
                    scopes: azureConfig.b2cScopes,
                  })
                  .then((res) => {
                    // Callback code here
                    onSuccess(res);
                    if (sessionStorage.getItem("LoginSucess") == "true") {
                      sessionStorage.setItem("LoginSucess", "false");
                      history.push("/terms");
                    }
                  })
                  .catch(async (errorVal) => {
                    console.log(errorVal);
                  });
              }
              console.log(error);
            });
        }
      })
      .catch((error) => {
        onFail({ error });
      });

    if (checkOnly) return;

    // Calls redirect callback above
    clientApplication.loginRedirect(tokenRequest());
  }
}

export function azureLogout(actions, state, history) {
  sessionStorage.setItem("isPageRefreshed", "false");
  sessionStorage.setItem("LoginSucess", "false");
  localStorage.clear();
  localStorage.setItem("orgid", null);
  localStorage.setItem("token", null);


  const logoutRequest = {
    account: clientApplication.getAccountByHomeId(
      state.azure.user.homeAccountId
    ),
  };

  clientApplication.logout(logoutRequest);
  actions.setAzureState(initState());
}
